import styled from 'styled-components';

export const ChatTabStyle = styled.div`
  position: relative;
  font-size: 16px;
  line-height: 20px;
  color: var(--light-gray);

  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    margin: 0 0 10px;
    color: var(--text-color);
  }

  .text {
    display: block;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: var(--light-gray);
  }

  .info-list {
    width: 100%;

    .btn {
      width: 100%;
      margin: 0 0 25px 0;
      padding: 0 20px 0 0;
      position: relative;
      text-align: left;

      &:hover {
        opacity: 0.8;
      }
    }

    .icon {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      font-size: 24px;
      line-height: 1;
    }
  }

  .holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 30px;

    .text-box {
      max-width: 600px;
    }
  }

  .switcher {
    flex-shrink: 0;
    width: 45px;
    display: inline-block;
    position: relative;

    input {
      display: none;

      &:checked ~ {
        .custom-label {
          background: #1a2a6c;

          &::before {
            left: 21px;
          }
        }
      }
    }

    .custom-label {
      display: block;
      position: relative;
      width: 45px;
      height: 26px;
      cursor: pointer;
      border-radius: 50px;
      background: #b0bec5;

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 22px;
        height: 22px;
        transition: all ease-in-out 0.3s;
        border-radius: 50px;
        background: #eceff1;
      }
    }
  }
`;
